var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
export let ServiceHtmlValidator = class ServiceHtmlValidator {
    validate(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const error = doc.querySelector('parsererror');
        // skip empty element
        return error
            ? null
            : doc.body.children.length > 1 || !!doc.body.firstElementChild?.innerHTML
                ? doc.body.innerHTML
                : null;
    }
};
ServiceHtmlValidator = __decorate([
    injectable()
], ServiceHtmlValidator);
